export const CHUNK_UPLOAD_PROGRESS = Symbol('CHUNK_UPLOAD_PROGRESS');
export const UPLOAD_INIT_VIDEO_OBJECT_SUCCESS = Symbol('UPLOAD_INIT_VIDEO_OBJECT_SUCCESS');
export const UPLOAD_INIT_VIDEO_OBJECT_REQUEST = Symbol('UPLOAD_INIT_VIDEO_OBJECT_REQUEST');
export const UPLOAD_FORM_CONFIG_REQUEST = Symbol('UPLOAD_FORM_CONFIG_REQUEST');
export const UPLOAD_FORM_CONFIG_SUCCESS = Symbol('UPLOAD_FORM_CONFIG_SUCCESS');
export const UPLOAD_PUBLISH_REQUEST = Symbol('UPLOAD_PUBLISH_REQUEST');
export const UPLOAD_PUBLISH_SUCCESS = Symbol('UPLOAD_PUBLISH_SUCCESS');
export const UPLOAD_RESET = Symbol('UPLOAD_RESET');
export const ABORT_UPLOAD = Symbol('ABORT_UPLOAD');

/**
 * @param {number} progress
 * @param {number} forChunk
 * @param {number} totalChunks
 * @return {{type: symbol, payload: {progress: *, forChunk: *, totalChunks: *}}}
 */
export const uploadProgressAction = (progress, forChunk, totalChunks) => ({
  type: CHUNK_UPLOAD_PROGRESS,
  payload: { progress, forChunk, totalChunks },
});

/**
 * @param {uploadVideoModel} video
 * @return {{type: symbol, payload: {video: uploadVideoModel}}}
 */
export const uploadInitVideoObjectSuccessAction = (video) => ({
  type: UPLOAD_INIT_VIDEO_OBJECT_SUCCESS,
  payload: { video },
});

export function uploadResetAction() {
  return {
    type: UPLOAD_RESET,
  };
}

export const abortUploadAction = () => ({ type: ABORT_UPLOAD });

/**
 * @param {File} file
 * @return {{type: *, payload: {file: *}}}
 */
export function uploadInitVideoObjectRequestAction(file, skipSelectVideo = false) {
  return {
    type: UPLOAD_INIT_VIDEO_OBJECT_REQUEST,
    payload: { file, skipSelectVideo },
  };
}

/**
 * Should represent upload object from store
 *
 * @param {*} uploadVideoObject
 * @return {{type: symbol | *, payload: *}}
 */
export function publishVideoRequestAction(uploadVideoObject) {
  return {
    type: UPLOAD_PUBLISH_REQUEST,
    payload: { uploadVideoObject },
  };
}

export function publishVideoSuccessAction(uploadVideoObject) {
  return {
    type: UPLOAD_PUBLISH_SUCCESS,
    payload: uploadVideoObject,
  };
}

export function uploadFormConfigRequestAction() {
  return {
    type: UPLOAD_FORM_CONFIG_REQUEST,
    payload: {},
  };
}

/**
 * @param {*[]} uploadFormConfig
 * @return {{type: symbol, payload: {uploadFormConfig: *[]}}}
 */
export function uploadFormConfigSuccessAction(uploadFormConfig) {
  return {
    type: UPLOAD_FORM_CONFIG_SUCCESS,
    payload: { uploadFormConfig },
  };
}
